import React from "react";
import { BrowserRouter, Switch, Route, RouteComponentProps } from "react-router-dom";
import PrivateRoute from "./Route/privateRoute";
import Login from "./Pages/Login";
import Logout from "./Pages/Logout";
import Dashboard from "./Pages/Dashboard";
import NotFound from "./Pages/NotFound";
import NoWorkspace from "./Pages/WorkspaceNotFound";
import NoWorkspaceModuleNoPermission from "./Pages/WorkspaceModuleNoPermission";
import NoIndustryOnWorkSpace from "./Pages/WorkspaceIndustryNotFound";
import PreparingWorkspace from "./Pages/WorkspacePreparing";
import "../src/styles/styles.css";

import CallbackLogin from "./Pages/Callback/Login";

import { AppContextProvider } from "./Context/AppContext";
import Layout from "./Components/Templates/Layout";
import AdminLayout from "./Components/Templates/Admin/Layout";
import TaxonomyIndex from "./Pages/GMS/Taxonomy/Index";
import VersionManagementIndex from "./Pages/Admin/VersionManagement/Index";
import GmsPdwManage from "./Pages/GMS/Pdw/Mange";
import GmsExportManage from "./Pages/GMS/Export/Mange";

import category from "./Pages/GMS/Taxonomy/Category";
import attribute from "./Pages/GMS/Taxonomy/Attribute";

import GMSDashboard from "./Pages/GMS/Dashboard/Dashboard";
import UserLogs from "./Pages/Admin/Logs/Index";

import UserProfile from "./Pages/User/Profile/Index";


import Landing_Dashboard from "./Pages/Landing/Dashboard";
import Task_Queue_Index from "./Pages/Admin/TaskQueue/Index";
import ProductViewManage from "./Pages/GMS/Products/view";
import ProductAddEdit from "./Pages/GMS/Products/addEdit";
import RuleAddEdit from "./Pages/GMS/Rules/RuleAddEdit";
import RuleView from "./Pages/GMS/Rules/RuleView";
import Search from "./Pages/GMS/Search";
import BuilderView from "./Pages/GMS/Builder/list";
import BuilderAddEdit from "./Pages/GMS/Builder/AddEdit";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CachePromotionView from "./Components/Admin/Cache/CachePromotionView";
import SettingsView from "./Components/Admin/Settings/SettingsView.jsx";
import EmptyPage from "./Pages/EmptyPage";
import BuilderDetail from "./Pages/GMS/Builder/BuilderDetail";
import ProductCategories from "Pages/GMS/Products/ProductCategories";
import ProductDeltaList from "Pages/GMS/Products";
import { ProductsContextProvider } from "Components/GMS/Products/ProductsContext";
import ConnectionsHome from "Components/Admin/connections/ConnectionsHome";
import AnalyticsProvider from "Pages/GMS/Performance/Context/AnalyticsProvider";
import AnalyticsDetailProvider from "Pages/GMS/Performance/Context/AnalyticsDetailProvider";

import { AnalyticsContextProvider } from "Pages/GMS/Performance/Context/AnalyticsContext";
import ARSComponent from "Pages/GMS/ARS";
import DocumentationPage from "Pages/GMS/Documentation";

import ISRProvider from "Pages/GMS/ISR/Context/ISRProvider";
import ISRMainProvider from "Pages/GMS/ISR/Context/ISRMainProvider";
import { ISRContextProvider } from "Pages/GMS/ISR/Context/ISRContext";
import ComputedSubstitutionEditComponent from "Pages/GMS/ComputedSubstitutions/pages/ComputedSubstitutionEdit";
import ListsView from "Pages/GMS/List/ListView";
import ListsEdit from "Pages/GMS/List/ListEdit";
import ABHomeProvider from "Pages/GMS/ABTesting/contexts/ABHomeProvider";
import ABDetailProvider from "Pages/GMS/ABTesting/contexts/ABDetailProvider";
import { ABContextProvider } from "Pages/GMS/ABTesting/contexts/ABContext";
import ArsModelComponent from "Pages/GMS/ARS/Components/ArsModel";
import ABResultProvider from "Pages/GMS/ABTesting/contexts/ABResultProvider";
import { CSContextProvider } from "Pages/GMS/ComputedSubstitutions/contexts/CSContext";
import { RuleContextProvider } from "Pages/GMS/Rules/contexts/RuleContext";
import { ArsContextProvider } from "Pages/GMS/ARS/Contexts/ArsContext";
import ListsDetails from "Pages/GMS/List/ListDetails";
import CategoryRelevancyPage from "Pages/GMS/CategoryRelevancy/pages";
import CSView from "Pages/GMS/ComputedSubstitutions/pages/CSView";
import IterationConfigurationProvider from "Pages/GMS/ComputedSubstitutions/components/iteration/IterationConfigurationProvider";
import ManageParty from "Pages/Admin/PartyManagement/ManageParty";
import PartyDetailProvider from "Pages/Admin/PartyManagement/context/PartyDetailProvider";
import ChannelDetailProvider from "Pages/Admin/PartyManagement/context/ChannelDetailProvider";
import MappingPage from "Pages/GMS/Mapping/Components/MappingPage";
import DesignSystemShowcase from "./Pages/DesignSystemShowcase/DesignSystemShowcase";

const App = () => {

  return (
    <AppContextProvider>
      <ProductsContextProvider>
        <AnalyticsContextProvider>
          <ISRContextProvider>
            <ABContextProvider>
              <BrowserRouter>
                <CSContextProvider>
                  <ArsContextProvider>
                    <RuleContextProvider>
                      <ToastContainer
                        position="bottom-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                      />
                      <Switch>
                        <Route path="/" exact={true} component={Login} />
                        <Route path="/login" exact={true} component={Login} />
                        <Route path="/logout" exact={true} component={Logout} />
                        <PrivateRoute
                          layout={Layout}
                          path="/workspace/empty"
                          exact
                          component={EmptyPage}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/workspace/notfound"
                          exact
                          component={NoWorkspace}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/workspace/module/permission/denied"
                          exact
                          component={NoWorkspaceModuleNoPermission}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/workspace/industry/notfound"
                          exact
                          component={NoIndustryOnWorkSpace}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/workspace/preparing"
                          exact
                          component={PreparingWorkspace}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/admin/party/manage"
                          exact
                          component={ManageParty}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/admin/party/domain/:id"
                          exact
                          component={PartyDetailProvider}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/admin/party/:partyId/domain/:domainId/channel"
                          exact
                          component={ChannelDetailProvider}
                        />
                        <PrivateRoute
                          layout={AdminLayout}
                          path="/admin/task/queue/info"
                          exact
                          component={Task_Queue_Index}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/dashboard"
                          exact
                          component={Dashboard}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/dashboard"
                          exact
                          component={GMSDashboard}
                        />
                        <PrivateRoute
                          path="/gms/products/list/:categoryid?"
                          layout={Layout}
                          exact
                          component={ProductDeltaList}
                        />
                        <PrivateRoute
                          path="/gms/products/category/list"
                          layout={Layout}
                          exact
                          component={ProductCategories}
                        />
                        {/* <PrivateRoute
                          path="/gms/mapping"
                          layout={Layout}
                          exact
                          component={MappingPage}
                        /> */}
                        <PrivateRoute
                          path="/gms/product/details/:id"
                          layout={Layout}
                          exact
                          component={ProductViewManage}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/ars"
                          exact
                          component={ARSComponent}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/ars/model/:modelId"
                          exact
                          component={ArsModelComponent}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/computed_substitutions"
                          exact
                          component={CSView}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/category_relevancy"
                          exact
                          component={CategoryRelevancyPage}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/computed_substitutions/:mode/:categoryid/:uid"
                          // Mode: edit | create_version
                          exact
                          component={ComputedSubstitutionEditComponent}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/computed_substitutions_iteration/:uid/edit"
                          exact
                          component={IterationConfigurationProvider}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/computed_substitutions_iteration/create"
                          exact
                          component={IterationConfigurationProvider}
                        />
                        <PrivateRoute
                          path="/gms/product/edit/:id"
                          layout={Layout}
                          exact
                          component={ProductAddEdit}
                        />
                        <PrivateRoute
                          path="/gms/rules/list/"
                          layout={Layout}
                          exact
                          component={RuleView}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/rule/:type/:id"
                          exact
                          component={(props: RouteComponentProps<{ type: string; id: string }>) => (
                            <RuleAddEdit key={props.match.params.id} {...props} />
                          )}
                        />
                        <Route
                          path="/callback/login"
                          exact={true}
                          component={CallbackLogin}
                        />
                        <Route
                          path="/landing/dashboard"
                          exact={true}
                          component={Landing_Dashboard}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/taxonomy"
                          exact
                          component={TaxonomyIndex}
                        />
                        <PrivateRoute
                          layout={AdminLayout}
                          path="/admin/versionmanagement/list"
                          exact
                          component={VersionManagementIndex}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/pdw"
                          exact
                          component={GmsPdwManage}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/taxonomy/category/:type?/:uid?"
                          exact
                          component={category}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/taxonomy/attribute/:uid?"
                          exact
                          component={attribute}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/taxonomy"
                          exact
                          component={TaxonomyIndex}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/versionmanagement/list"
                          exact
                          component={VersionManagementIndex}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/admin/settings"
                          exact
                          component={SettingsView}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/admin/cache"
                          exact
                          component={CachePromotionView}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/user/profile"
                          exact
                          component={UserProfile}
                        />
                        <PrivateRoute
                          layout={AdminLayout}
                          path="/admin/logs"
                          exact
                          component={UserLogs}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/export"
                          exact
                          component={GmsExportManage}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/search/:query?"
                          exact
                          component={Search}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/builder"
                          exact
                          component={BuilderView}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/builder/edit/:id"
                          exact
                          component={BuilderAddEdit}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/builder/detail/:id"
                          exact
                          component={BuilderDetail}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/catalog/manage"
                          exact
                          component={NoWorkspaceModuleNoPermission}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/performance"
                          exact
                          component={AnalyticsProvider}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/performance/detail/:name"
                          exact
                          component={AnalyticsDetailProvider}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/admin/connection"
                          exact
                          component={ConnectionsHome}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/guide"
                          exact
                          component={ISRProvider}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/guide/main/:name/:id"
                          exact
                          component={ISRMainProvider}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/isr"
                          exact
                          component={ISRProvider}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/isr/main/:name/:id"
                          exact
                          component={ISRMainProvider}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/documentation"
                          exact
                          component={DocumentationPage}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/taxonomy/lists"
                          exact
                          component={ListsView}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/taxonomy/lists/edit/:editId"
                          exact
                          component={ListsEdit}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/taxonomy/lists/view/:id"
                          exact
                          component={ListsDetails}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/ab"
                          exact
                          component={ABHomeProvider}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/ab/detail/:id"
                          exact
                          component={ABDetailProvider}

                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/gms/ab/result/:id"
                          exact
                          component={ABResultProvider}
                        />
                        <PrivateRoute
                          layout={Layout}
                          path="/design-system"
                          exact
                          component={DesignSystemShowcase}
                        />
                        <Route path="*" component={NotFound} />
                      </Switch>
                    </RuleContextProvider>
                  </ArsContextProvider>
                </CSContextProvider>
              </BrowserRouter>
              <div id="dropdown-portal" ></div>
              <div id="modal-root" className="tw-z-[5000] relative"></div>
            </ABContextProvider>
          </ISRContextProvider>
        </AnalyticsContextProvider>
      </ProductsContextProvider>

    </AppContextProvider>
  );
}

export default App;